import { Environment } from 'multirpc-sdk';

export const API_ENV = (import.meta.env.MODE || 'stage') as Environment;

export const IS_PROD = API_ENV === 'prod' || API_ENV === 'analyze';

export const IS_LOCAL = import.meta.env.VITE_IS_LOCAL === 'true';

export const ENV_SSR = import.meta.env.SSR;

export const ENV_SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN;

export const ENV_NAME = import.meta.env.VITE_NAME;

export const ENV_VERSION = import.meta.env.VITE_VERSION;

export const ENV_HOMEPAGE = import.meta.env.HOMEPAGE;
